import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class APIConfigurationService {
    static createAPIKey(grants) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${ROOT}api-keys`, grants)
                .then((response) => {
                    resolve({ apiKey: response.data });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    static deleteAPIKey(id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`${ROOT}api-keys/${id}`)
                .then((_) => {
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    static getAPIKeys() {
        return new Promise((resolve, reject) => {
            axios
                .get(`${ROOT}api-keys`)
                .then((response) => {
                    resolve({ apiKeys: response.data });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
}

export default APIConfigurationService;